import script from "./StakingAmount.vue?vue&type=script&setup=true&lang=ts"
export * from "./StakingAmount.vue?vue&type=script&setup=true&lang=ts"

import "./StakingAmount.vue?vue&type=style&index=0&id=37a5997b&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37a5997b"]])

export default __exports__